import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryDashboardSnapshot } from '@/renderer/services/inventoryDashboardService';
import type { InventoryDashboardFilterParams } from '@/renderer/types/inventory';

export function useInventoryDashboard(params: InventoryDashboardFilterParams) {
  return useQuery({
    queryKey: queryKeys.inventory.dashboard(params),
    queryFn: async () => {
      const result = await fetchInventoryDashboardSnapshot(params);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch inventory dashboard');
      }

      return result.data;
    },
    enabled:
      !!params.companyId &&
      !!params.outletId &&
      !!params.dateFrom &&
      !!params.dateTo,
  });
}
